import apiClient from "utils/apiClient";
import { PM_SERVICE_BASE_URL } from "constants";

const QA_API_URL = `${PM_SERVICE_BASE_URL}/api/v1/qa/apps`;

const unwrap = (response) => response.data;

const withPagination = (params = {}) => {
  const { page = 0, size = 20, ...rest } = params;
  return { page, size, ...rest };
};

export const qaApi = {
  apps: {
    list: async (params = {}) =>
      apiClient
        .get(QA_API_URL, { params: withPagination(params) })
        .then(unwrap),

    get: async (appId) => apiClient.get(`${QA_API_URL}/${appId}`).then(unwrap),

    create: async (data) => apiClient.post(QA_API_URL, data).then(unwrap),

    update: async (appId, data) =>
      apiClient.put(`${QA_API_URL}/${appId}`, data).then(unwrap),

    delete: async (appId) => apiClient.delete(`${QA_API_URL}/${appId}`).then(unwrap),

    getHistory: async (appId, params = {}) =>
      apiClient
        .get(`${QA_API_URL}/${appId}/history`, {
          params: withPagination(params),
        })
        .then(unwrap),
  },

  features: {
    list: async (appId, params = {}) =>
      apiClient
        .get(`${QA_API_URL}/${appId}/features`, {
          params: withPagination(params),
        })
        .then(unwrap),

    get: async (appId, featureId) =>
      apiClient
        .get(`${QA_API_URL}/${appId}/features/${featureId}`)
        .then(unwrap),

    create: async (appId, data) =>
      apiClient.post(`${QA_API_URL}/${appId}/features`, data).then(unwrap),

    update: async (appId, featureId, data) =>
      apiClient
        .put(`${QA_API_URL}/${appId}/features/${featureId}`, data)
        .then(unwrap),

    delete: async (appId, featureId) =>
      apiClient
        .delete(`${QA_API_URL}/${appId}/features/${featureId}`)
        .then(unwrap),

    getHistory: async (appId, featureId, params = {}) =>
      apiClient
        .get(`${QA_API_URL}/${appId}/features/${featureId}/history`, {
          params: withPagination(params),
        })
        .then(unwrap),

    getResults: async (appId, featureId) =>
      apiClient
        .get(`${QA_API_URL}/${appId}/features/${featureId}/results`)
        .then(unwrap),

    saveResult: async (appId, featureId, data) =>
      apiClient
        .post(`${QA_API_URL}/${appId}/features/${featureId}/results`, data)
        .then(unwrap),

    updateResult: async (appId, featureId, resultId, data) =>
      apiClient
        .put(
          `${QA_API_URL}/${appId}/features/${featureId}/results/${resultId}`,
          data
        )
        .then(unwrap),

    deleteResult: async (appId, featureId, resultId) =>
      apiClient
        .delete(`${QA_API_URL}/${appId}/features/${featureId}/results/${resultId}`)
        .then(unwrap),

    getResultsHistory: async (appId, featureId, subFeature, params = {}) =>
      apiClient
        .get(`${QA_API_URL}/${appId}/features/${featureId}/results-history`, {
          params: {
            ...withPagination(params),
            subFeature,
          },
        })
        .then(unwrap),
  },

  runs: {
    list: async (appId, featureId, params = {}) =>
      apiClient
        .get(`${QA_API_URL}/${appId}/features/${featureId}/runs`, {
          params: withPagination(params),
        })
        .then(unwrap),

    get: async (appId, featureId, runId) =>
      apiClient
        .get(`${QA_API_URL}/${appId}/features/${featureId}/runs/${runId}`)
        .then(unwrap),

    create: async (appId, featureId, data) =>
      apiClient
        .post(`${QA_API_URL}/${appId}/features/${featureId}/runs`, data)
        .then(unwrap),

    delete: async (appId, featureId, runId) =>
      apiClient
        .delete(`${QA_API_URL}/${appId}/features/${featureId}/runs/${runId}`)
        .then(unwrap),
  },
};

export default qaApi;
